/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgContains = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M17 5h3v14h-3v2h5V3h-5v2zM3 3H2v18h5v-2H4V5h3V3H3zm8.084 4.276L7.77 16h2.004l.576-1.788h3.216L14.144 16h2.088l-3.336-8.724h-1.811zm1.968 5.352h-2.197l1.092-3.432 1.105 3.432z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgContains as Contains };
